var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c('EqsAvatarUpload',_vm._b({attrs:{"value":_vm.entity.avatar,"user":_vm.entity,"el-class":"entity-avatar-upload"},on:{"update:value":_vm.updateEntityAvatar}},'EqsAvatarUpload',{ loading: _vm.loadingPicture || _vm.loading },false)),_c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c('EqsTextDisplay',_vm._b({staticClass:"mb-5"},'EqsTextDisplay',{
                elClass: 'profile-name',
                loading: _vm.loading,
                value: _vm.entity.name,
                eqsType: 'subtitle'
            },false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }